module.exports = __webpack_public_path__ + "static/media/icon_cross-circle.116a2408.svg";